import React from 'react';
import './Cardlist.css';
import bee_theme from "../assets/img/ProjectPage_img/ProjectPage_img/bee_theme.png";
import ocean_theme from "../assets/img/ProjectPage_img/ProjectPage_img/ocean_theme.png";
import candy_theme from "../assets/img/ProjectPage_img/ProjectPage_img/candy_theme.png";
import sport_theme from "../assets/img/ProjectPage_img/ProjectPage_img/sport_theme.png";
const Cardlist = () => {
  return (
    <section className="cardlist-section" data-aos="zoom-out-down"  data-aos-duration="2500">
 
    <div className="column">
      <div className="cardlist-card" onClick={() => document.getElementById("babydaydiv").scrollIntoView({ behavior: "smooth" })}
  style={{ cursor: "pointer" }}>
        <img src={bee_theme} alt="GEM Bee Theme 2023" className="cardlist-image" />
        <p className="cardlist-name">Baby Day</p>
      </div>
      
    </div>
 
    <div className="column">
      <div className="cardlist-card" onClick={() => document.getElementById("peekaboodiv").scrollIntoView({ behavior: "smooth" })}
  style={{ cursor: "pointer" }}>
        <img src={ocean_theme} alt="GEM Ocean Theme 2023" className="cardlist-image" />
        <p className="cardlist-name">Peekaboo</p>
      </div>
      
    </div>

    
    <div className="column">
      <div className="cardlist-card" onClick={() => document.getElementById("irbiddiv").scrollIntoView({ behavior: "smooth" })}
  style={{ cursor: "pointer" }}>
        <img src={sport_theme} alt="GEM Sport Theme 2023" className="cardlist-image" />
        <p className="cardlist-name">Irbid Landmark</p>
      </div>
      
    </div>

    
    
    </section>
  )
}

export default Cardlist